import { Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import {
  ACTION_ICON,
  ACTION_NAME_KEY,
  ACTION_ROW_META
} from "../takenActions.selector"
import { ActionReference } from "./ActionReference"
import { ActionRowMenu } from "./ActionRowMenu"
import { ActionStatusBadge } from "./ActionStatusBadge"

import styles from "../TakenActions.module.scss"

import type { TakenAction } from "../TakenActions.types"

type Props = {
  action: TakenAction
  onRemove: () => void
}

export const ActionRow = ({ action, onRemove }: Props) => {
  const { t } = useTranslation()
  const Icon = ACTION_ICON[action.type]
  const { isLink, hasOverflow } = ACTION_ROW_META[action.type]
  const name = t(
    `triage.remediation.actions.types.${ACTION_NAME_KEY[action.type]}`
  )

  return (
    <div className={styles.row}>
      <div className={styles.rowMain}>
        <Icon className={styles.rowIcon} />
        <Text className={styles.rowName}>{name}</Text>
        {action.reference && (
          <ActionReference
            reference={action.reference}
            isLink={isLink}
            link={action.link}
            extraCount={action.extraCount}
            extraReferences={action.extraReferences}
          />
        )}
        {action.status && <ActionStatusBadge status={action.status} />}
      </div>
      {hasOverflow && (
        <div className={styles.rowAside}>
          <ActionRowMenu onRemove={onRemove} />
        </div>
      )}
    </div>
  )
}
